import { UserAbsence } from "./userAbsences.reducer"

export enum Types {
  GET = "GET_USER_ABSENCES",
  GET_SUCCESS = "GET_USER_ABSENCES_SUCCESS",
  GET_FAIL = "GET_USER_ABSENCES_FAIL",
}

export type Action = GetUserAbsencesAction | GetUserAbsencesSuccessAction | GetUserAbsencesFailAction

export type GetUserAbsencesAction = {
  type: Types.GET
  payload: { params: { year: string; uid: string } }
}

export type GetUserAbsencesSuccessAction = {
  payload: { data: UserAbsence[] | undefined }
  type: Types.GET_SUCCESS
}

export type GetUserAbsencesFailAction = {
  payload: { errors: object }
  type: Types.GET_FAIL
}

export function getUserAbsences(params: { year: string; uid: string }): GetUserAbsencesAction {
  return {
    type: Types.GET,
    payload: {
      params,
    },
  }
}

export function getUserAbsencesSucces(data: UserAbsence[] | undefined): GetUserAbsencesSuccessAction {
  return {
    payload: { data },
    type: Types.GET_SUCCESS,
  }
}

export function getUserAbsencesFail(errors: object): GetUserAbsencesFailAction {
  return {
    payload: { errors },
    type: Types.GET_FAIL,
  }
}
